// Constants.tsx

import { ODataOrderByDirection } from 'src/util/ODataBuilder';

export const landTractTypes = Object.freeze({
    SURFACE : 'Surface',
    MINERAL : 'Mineral'
});

export const contractStatus = Object.freeze({
    OPEN : 'Open',
    LEASED : 'Leased'
});

export const leaseTypes = Object.freeze({
    OIL_AND_GAS : 'Oil and Gas Lease',
    SURFACE_WAIVER : 'Surface Waiver',
    SOLAR : 'Solar Lease',
    BATTERY_STORAGE : 'BESS Lease',
    BRINE_LEASE : 'Brine Lease'
});

export const documentTemplateTypes = Object.freeze({
    LEASE_TEMPLATE : 'Lease Template',
    ORDER_OF_PAYMENT : 'Order of Payment',
    MEMO: 'Memo'
});

export const LeaseStatus = Object.freeze({
    ROUGH_DRAFT : 1,
    IN_HAND : 2,
    INVOICED : 3,
    RECORDED : 4,
    TRANSMITTED : 5,
    VOID : 6
});

// The delay (in ms) for query execution while typing in a search query on the GIS Data Access Page
export const gisDataAccessSearchDebounceDelay = 800;

// The number of rows to return for each paginated request for GIS Horizons in a search query on the GIS Data Access Page.
export const gisDataAccessSearchRowCount = 15;

// The number of rows to return for each paginated requrest for projects on the Clients Page.
export const clientPageProjectListDefaultRowCount = 15;
export const clientPageProjectQueryOrderByIdColumn = 'Id';
export const clientPageProjectQueryOrderByNameColumn = 'Name';
export const clientPageProjectQueryOrderByProjectNumberColumn = 'ProjectNumber';
export const clientPageProjectQueryStartingPage = 1;

// Constants for Pagination in the SearchPanel Component.
export const SearchPanelQueryNoOpResult = 'SearchPanelQueryNoOpResult';
export const SearchPanelTagListDefaultRowCount = 15;
export const SearchPanelQueryOrderByNameColumn = 'Name';
export const SearchPanelQueryStartingPage = 1;
export const SearchPanelTagListQueryOrderByDirection = ODataOrderByDirection.Descending;

// The number of bytes that a file can be in order to be contained in a FormData File blob
export const MaxUploadFileSizeBytes: number = 29360128;

// Default Lessee
export const DefaultLesseePageFormSubmitText = 'Submit';
export const ProvisionalOwnerName = 'provisional';

// Get index 0 because on the leaseinfo.redesign.tsx page, only one leasehold at a time is fetched
export const leaseInfoPagedefaultLeaseholdIndex = 0;
export const refreshMORReportFileType = 2;

export const accountsPayableVoucherAccountsBlankAccountsBase = 999000;
export const accountsPayableVoucherAccountsUnsavedAccountsBase = 1000000;



// WEBPACK FOOTER //
// ./src/components/common/Constants.tsx